/**
 * Generates a unique dashboard name based on the count of existing dashboards.
 * If there are N existing dashboards, the new one gets number N+1.
 */
export function getNewDashboardName(dashboardCount: number, baseName: string): string {
  return dashboardCount > 0 ? `${baseName} ${dashboardCount + 1}` : baseName;
}
